export default function Warning({total_non_reported, inline}) {
    return(
        total_non_reported > 0 ?
        (
            inline ?
            (<span className="badge badge-danger badge-corner animate fadeInOut rounded-circle position-absolute custom text-white"
            style={{ width: '10px', height: '10px', fontSize: "0.5rem", top: "16px", insetInlineStart:"7px" }}>!</span>)
            :
            (<span className="badge badge-danger badge-corner animate fadeInOut rounded-circle position-absolute custom text-white"
            style={{ width: '10px', height: '10px', fontSize: "0.5rem", top: "2px", paddingInlineStart:"4px", paddingBlockStart:"1px", insetInlineEnd:"1px" }}>!</span>)
        )
        :
        null
    )
}